export default {
    admin: true,
    inventoryVendors: [],
    lcodeManufacturerWhitelist: [],
};
